import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { ThreadType } from '../index';

interface CustomChatSwitchProps {
  activeType: ThreadType;
  changeChatType: (type: ThreadType) => void;
  setOpenPrivateChat: (chat: any) => void;
}

const CustomChatSwitch: React.FC<CustomChatSwitchProps> = ({ activeType, changeChatType, setOpenPrivateChat }) => {
  const dispatch = useDispatch<AppDispatch>();
  // const { commonCount, privateCounts } = useSelector((state: RootState) => state.live.chats);
  // const totalPrivateCount = privateCounts.reduce((sum, thread) => sum + thread.count, 0);

  const handleChangeType = (type: ThreadType) => {
    changeChatType(type);
    setOpenPrivateChat(null);
    if (type === 'class') {
      // dispatch(resetCommonCount());
    } else {
      // privateCounts.forEach((thread) => dispatch(resetPrivateCount(thread.id)));
    }
  };

  return (
  <div className="flex w-full bg-[#38393F] px-2 pt-2 gap-2">
    <button
      className={`relative flex-1 rounded-t-3xl px-4 py-2 text-sm font-medium transition-all duration-200 ${
        activeType === "class"
          ? "bg-[#5F488A] text-white shadow"
          : "bg-[#545455] text-white"
      }`}
      onClick={() => handleChangeType("class")}
    >
      Common Chat
      {/* {commonCount > 0 && (
        <span className="absolute -top-1 -right-2 bg-red-600 text-white rounded-full text-[10px] px-1.5 py-0.5">
          {commonCount}
        </span>
      )} */}
    </button>

    {/* <button
      className={`relative flex-1 rounded-t-3xl px-4 py-2 text-sm font-medium transition-all duration-200 ${
        activeType === "individual"
          ? "bg-[#5F488A] text-white shadow"
          : "bg-[#545455] text-white"
      }`}
      onClick={() => handleChangeType("individual")}
    >
      Private Chat
      {totalPrivateCount > 0 && (
        <span className="absolute -top-1 -right-2 bg-red-600 text-white rounded-full text-[10px] px-1.5 py-0.5">
          {totalPrivateCount}
        </span>
      )}
    </button> */}
  </div>
);
};

export default CustomChatSwitch;